export function emailValidationInit() {
  const $email = $('.email-validator');
  $email.each((i, el) => {
    const $el = $(el);

    $el.on('blur', (e) => {
      const valid = validateEmail($el.val());

      if (valid) {
        $el.removeClass('error');
      } else {
        $el.addClass('error');
      }
    });
  });
}

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
